import Spinner from '@repo/shared/Spinner'
import clsx from 'clsx'
import {ButtonHTMLAttributes, FC, ReactNode} from 'react'

interface IButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  color?: 'blue' | 'purple' | 'orange' | 'black'
  className?: string
  buttonClassName?: string
  icon?: ReactNode
  isLoading?: boolean
  id?: string
}

export const ActionButton: FC<IButtonProps> = ({
  children,
  onClick,
  disabled,
  color = 'blue',
  className,
  buttonClassName,
  icon,
  isLoading,
  id,
}: IButtonProps) => {
  const isDisabled = disabled || isLoading

  return (
    <div className={clsx('relative h-[56px]', className)}>
      <button
        disabled={isDisabled}
        id={id}
        onClick={onClick}
        className={clsx(
          'absolute left-0 top-0 z-10 h-[50px] w-full rounded-2xl',
          'pointer-events-auto disabled:cursor-not-allowed',
          'text-xl uppercase text-white',
          'mb-[6px] px-4 pb-[14px] pt-3',
          color === 'blue' && 'bg-[#004df5]',
          color === 'purple' && 'bg-[#b800ff]',
          color === 'orange' && 'bg-[#f15f2b]',
          color === 'black' && 'bg-[#040100]',
          !isDisabled &&
            'transition-transform ease-in-out hover:-translate-y-[-3px] active:-translate-y-[-3px]',
          buttonClassName,
        )}
      >
        <div
          className={clsx(
            'flex w-full flex-col items-center justify-center',
            isDisabled && 'opacity-50',
          )}
        >
          {icon && <div>{icon}</div>}
          {children}
        </div>
      </button>

      {isLoading && (
        <div className="absolute top-0 z-20 flex h-full w-full items-center justify-center pb-1">
          <Spinner />
        </div>
      )}

      <div
        className={clsx(
          'absolute bottom-0 h-[40px] w-full rounded-[18px]',
          color === 'blue' && 'bg-[#0335a6]',
          color === 'purple' && 'bg-[#7e06ad]',
          color === 'orange' && 'bg-[#c54e23]',
          color === 'black' && 'bg-[#262626]',
        )}
      />
    </div>
  )
}
